import React from 'react';
import PropTypes from 'prop-types';
import createDOMPurify from 'dompurify';
import classnames from 'classnames';

import styles from './RichTextView.scss';

export default function RichTextView(props) {
  const {children, className, ...restProps} = props;
  const DOMPurify = createDOMPurify(window);

  const handleRender = (element, key) => {
    if (Array.isArray(element)) {
      return element.map(handleRender);
    }

    if (typeof element !== 'string') {
      return element;
    }

    const purifiedChildren = DOMPurify.sanitize(element, {ALLOWED_TAGS: ['p', 'br', 'em', 'strong', 'ul', 'li']});

    return (
      <span
        dangerouslySetInnerHTML={{__html: purifiedChildren}}
        key={key}
        {...restProps}
      />
    );
  }

  return (
    <div
      className={classnames(styles.text, className)}
    >
      {handleRender(children)}
    </div>

  )
}

RichTextView.propTypes = {
  className: PropTypes.string,
};

RichTextView.defaultProps = {
  className: null,
};



// WEBPACK FOOTER //
// ./src/components/controls/RichTextView.jsx